import type { RouteDef } from '../router';
import { t } from '../i18n';
import { escapeHtml } from '../utils';

const notFound: RouteDef = {
  path: '*',
  routeType: '404',
  metaTitle: 'Not found — Roamzy',
  metaDesc: 'The page you\'re looking for might have moved, or the link was mistyped.',
  render() {
    return `
<section class="route is-active" data-route="404">
  <div class="container" style="padding: 120px 0; text-align: center;">
    <p class="label label--accent" data-i18n="notFound.kicker">${escapeHtml(t('notFound.kicker'))}</p>
    <h1 style="font-size: clamp(3rem, 8vw, 6rem); margin: 24px 0;">${escapeHtml(t('notFound.title'))}</h1>
    <p style="margin: 0 auto 32px; max-width: 480px;" data-i18n="notFound.body">${escapeHtml(t('notFound.body'))}</p>
    <a class="btn btn--accent" href="/" data-i18n="notFound.back">${escapeHtml(t('notFound.back'))}</a>
  </div>
</section>
`;
  },
};

export default notFound;
